import ReactPixel from 'react-facebook-pixel'
import { jwtDecode } from 'jwt-decode'

/**
 * Meta pixel bootstrap and identity.
 *
 * Advanced matching is only read at init, so a customer who signs in after
 * accepting cookies would otherwise never reach Meta and their conversions
 * could not be matched back to them. Re-running init re-applies it.
 */

let pixelId: string | null = null

const applyAdvancedMatching = (id: string, customerId?: string): void =>
  ReactPixel.init(
    id,
    { external_id: customerId } as any, // bad lib types
    {
      debug: import.meta.env.DEV,
      autoConfig: true,
    }
  )

/**
 * Loads the pixel for this marketplace and records the customer, when known.
 *
 * The pixel library injects Meta's script before it validates the id, so a
 * marketplace with no pixel configured must not call this at all.
 */
export const initMetaPixel = (id: string, customerId?: string): void => {
  pixelId = id
  applyAdvancedMatching(id, customerId)
  ReactPixel.pageView()
}

/** Re-applies advanced matching once the customer is known. */
export const identifyMetaPixel = (customerId: string): void => {
  if (!pixelId) return
  applyAdvancedMatching(pixelId, customerId)
}

/** Identifies the customer from a JWT after login/register. No-op before consent. */
export const identifyMetaFromToken = (token?: string | null): void => {
  if (!token) return
  try {
    const { customer_id: customerId } = jwtDecode<{ customer_id: string }>(
      token
    )
    if (customerId) identifyMetaPixel(customerId)
  } catch {
    // malformed token - skip identify
  }
}
